<header class="header" id="inicio">
  <div class="header-container">

    <a href="/" class="logo">
      <img src="/LogoColorida.svg" alt="Paraíso do Cerrado">
    </a>

    <nav class="nav">
      <a href="/">Início</a>
      <a href="#acomodacoes">Acomodações</a>
      <a href="https://www.google.com/maps/place/Para%C3%ADso+do+Cerrado/data=!4m2!3m1!1s0x0:0x1024103b695b8bd1?sa=X&ved=1t:2428&ictx=111">Localização</a>
      <a href="#suporte">Suporte</a>
    </nav>

    <a href="#reserva" class="btn-reserva">
      Reserve Já!
    </a>

    <button
      class="menu-toggle"
      (click)="toggleMenu()"
      [class.active]="menuAberto"
      aria-label="Abrir menu">

      <span></span>
      <span></span>
      <span></span>

    </button>

  </div>
</header>

<div
  class="menu-overlay"
  [class.active]="menuAberto"
  (click)="fecharMenu()">
</div>

<aside
  class="mobile-menu"
  [class.active]="menuAberto">

  <div class="mobile-menu-header">

    <button
      class="menu-close"
      (click)="fecharMenu()"
      aria-label="Fechar menu">
      ×
    </button>

  </div>

  <nav class="mobile-nav">

    <a
      href="#inicio"
      (click)="fecharMenu()">
      Início
    </a>

    <a
      href="#acomodacoes"
      (click)="fecharMenu()">
      Acomodações
    </a>

    <a
      href="#localizacao"
      (click)="fecharMenu()">
      Localização
    </a>

    <a
      href="#suporte"
      (click)="fecharMenu()">
      Suporte
    </a>

    <a
      href="#reserva"
      class="mobile-btn-reserva"
      (click)="fecharMenu()">

      Reserve Já!

    </a>

  </nav>

</aside>
